module.exports = __webpack_public_path__ + "img/logo.d95aea4e.svg";